// extracted by mini-css-extract-plugin
export default {"cpvMiniChart":"IX7D3X99v0671rnewWmQ__cpvMiniChart___","chartBars":"MgIuRAzLwR7b0UgZ2dwu__chartBars___","title":"YVrer8OZfTHhgrJGZQ8w__title___"};